module.exports = __webpack_public_path__ + "img/1.f43eb73d.jpg";